<template>
  <div>
    <div v-if="!checkUserHasTicket && contentPrice" class="trapezoid-card">
      <p>
        <span>{{ contentPrice.currencysymbol }}</span>
        {{ contentPrice.amount / 100 }}
      </p>
    </div>
    <!-- <div v-if="!checkUserHasTicket && content.price" class="triangle-bottom"></div>    
    <div v-if="!checkUserHasTicket && content.price" class="triangle-top"></div>-->
    <div class="content-card" :style="{
      'background-image': `url(${ poster })`,
    }">
      <img
        v-if="content.continueWatching"
        class="play-button"
        @click="playContent()"
        src="@/assets/icons/sdgPlay.svg"
      />
      <!-- <img :src="(content.posters.length > 1) ? content.posters[1].url : content.posters[0].url"/> showContentDetailEvent bookContent()-->
      <div class="hover-effect" @click="detailClick()">
        <div class="content">
          <div class="tags">
            <div class="card-book-btn" v-if="!content.continueWatching">
              <button
                class="btn-lg-primary purchasebtn"
                ref="bookNowBtn"
                @click="bookContent"
              >{{ checkUserHasTicket ? 'Watch Now' : 'Watch Trailer'}}</button>
            </div>
            <!-- Details  -->
            <div class="card-arrow-down-small" v-if="!content.continueWatching">
              <p>More Details</p>
              <img src="@/assets/icons/Ic_viewmore.svg" />
            </div>
            <div class="card-book-btn" v-if="content.continueWatching">
              <button
                class="btn-lg-primary purchasebtn"
                ref="bookNowBtn"
                @click="removeFromContinueWatching"
              >Remove</button>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div
        class="card-progress"
        v-if="progress && (checkUserHasTicket || content.continueWatching)"
      >
        <div
          class="progress-percent"
          :id="`progress-${content.contentid}`"
          :style="{ width: progress + '%' }"
        ></div>
      </div>
    </div>
    <div v-if="showDownArrow && !content.continueWatching" class="detail-arrow">
      <img src="@/assets/icons/sort-down-50.png" />
    </div>
  </div>
</template>

<script>
import Utility from "@/mixins/Utility";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { EventBus } from "@/main";
import firebase from "firebase/app";
import "firebase/database";

export default {
  props: {
    showContentDetailEvent: {
      type: Function
    },
    removeContent: {
      type: Function
    },
    content: {
      type: Object
    }
  },
  data() {
    return {
      progress: null,
      showCompleted: false,
      showWatchlistBtn: false,
      showDownArrow: false,
      contentStatus: "PURCHASE",
      checkUserHasTicket: false,
      contentPrice: null
    };
  },
  components: {},
  watch: {
    subscriberid() {
      if (this.subscriberid) {
        this.getCardProgress();
      }
    },
    currency() {
      if (this.currency && !this.content.continueWatching) {
        this.getContentCurrency();
      }
    }
  },
  computed: {
    ...mapGetters(["vendorid", "subscriberid", "currency"]),
    poster() {
      if (this.content.posters && this.content.posters.length) {
        let portraitposters = this.content.posters.filter(
          pos => pos.orientation === "PORTRAIT"
        );
        if (portraitposters.length == 0)
          portraitposters = this.content.posters.filter(
            pos => pos.orientation === "LANDSCAPE"
          );
        if (portraitposters.length) {
          let posterIndex = portraitposters.findIndex(
            pos => pos.quality === "HD"
          );
          if (posterIndex > -1) {
            return portraitposters[posterIndex].url;
          } else {
            return portraitposters[0].url;
          }
        }
      } else {
        return this.content.poster;
      }
    }
  },
  created() {
    // console.log('content array', this.content);
    if (!this.content.ticketStatus) this.content.ticketStatus = false;
    // if (this.subscriberid) this.checkUserBoughtTicket();
    if (this.content.purchaseDetails) {
      this.checkUserHasTicket = true;
      this.content.ticketStatus = true;
      this.contentStatus = "Watch";
    }
    if (this.subscriberid) {
      this.getCardProgress();
    }
    if (this.currency && !this.content.continueWatching) {
      this.getContentCurrency();
    }
  },
  mounted() {
    EventBus.$on("closeAllArrow", () => {
      this.showDownArrow = false;
    });
    EventBus.$on(`show-Movies-${this.content.title}-downarrow`, () => {
      this.showDownArrow = true;
    });
    EventBus.$on(`ticketStatus-${this.content.contentid}`, data => {
      this.checkUserHasTicket = true;
      // this.checkUserBoughtTicket();
      if (data) {
        this.content.ticketStatus = true;
        this.contentStatus = "Watch";
        this.content.purchaseDetails = data;
      }
    });
  },
  beforeDestroy() {
    EventBus.$off(`ticketStatus-${this.content.contentid}`, data => {});
  },
  methods: {
    ...mapActions(["actGetToken"]),
    getContentCurrency() {
      this.contentPrice = this.getContentPrice(this.content);
    },
    removeFromContinueWatching(e) {
      e.stopPropagation();
      this.removeContent(this.content.contentid);
    },
    detailClick() {
      if (this.isMobile()) {
        if (window.innerWidth < 1990) {
          this.$router.push({
            name: "Detail",
            params: {
              id: this.content.contentid
            }
          });
        }
      } else {
        if (!this.content.continueWatching) this.showContentDetailEvent();
      }
    },
    // Get the progress data
    getCardProgress() {
      let content = this.content;
      let contentid = content.contentid;
      let contenttype = content.contenttype;
      // Create the firebase paths to fetch the data
      let path = `${this.vendorid}/subscriber/${this.subscriberid}/content/${contentid}`;

      firebase
        .database()
        .ref(path)
        .on("value", snapshot => {
          if (snapshot.val()) {
            let response = snapshot.val();
            if (
              (response.status === "INPROGRESS" ||
                response.status === "COMPLETED") &&
              response.watchedduration > 9 &&
              new Date(response.expiry) >= new Date()
            ) {
              let duration = response.duration;
              let watched = response.watchedduration;
              let progress = (watched / duration) * 100;
              if (progress > 0 && progress < 100) {
                this.progress = progress;
                this.content.progress = progress;
              }
            } else {
              this.progress = this.content.progress = null;
            }
          }
        });
    },
    checkUserBoughtTicket() {
      if (localStorage.getItem("tickets")) {
        let ticketList = JSON.parse(localStorage.getItem("tickets"));
        if (ticketList) {
          let content = ticketList.findIndex(
            ele => ele.contentid == this.content.contentid
          );
          if (content > -1) {
            this.content.ticketStatus = true;
            this.contentStatus = "Watch";
          }
        }
      }
    },
    playContent() {
      if (this.subscriberid) {
        EventBus.$emit("showPlayer", this.content);
      }
    },
    bookContent(e) {
      e.stopPropagation();
      EventBus.$emit("showPlayer", this.content, "T");
      if (!this.subscriberid) {
        // EventBus.$emit('LoginPopup')
        EventBus.$emit("showPlayer", this.content, "T");
      } else if (
        this.subscriberid &&
        this.content.ticketStatus &&
        !this.content.continueWatching
      ) {
        // EventBus.$emit('PaymentPopup',this.content)
        EventBus.$emit("showPlayer", this.content);
      }
    },
    checkPremiering() {
      let status = false;
      if (this.content.fromdate && this.content.todate) {
        let currentDate = new Date();
        let fromDate = new Date(this.content.fromdate);
        let toDate = new Date(this.content.todate);
        if (currentDate >= fromDate && currentDate <= toDate) status = true;
      }
      return status;
    }
  },
  mixins: [Utility]
};
</script>

<style lang="scss">
.content-card {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  // min-width: 270px;
  height: 500px;
  background-image: url("./placeholder.png");
  background-size: cover;
  // background-position: center center;
  // margin-bottom: 20px;

  // &.inactive {
  //   &::after {
  //     content: '';
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     width: 100%;
  //     height: 100%;
  //     // background: linear-gradient(0deg,rgba(0,0,0,.9),transparent);
  //     // transition: all 0.3s ease;
  //   }
  // }

  // &::before {
  //   content: '';
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   width: 100%;
  //   // background: linear-gradient(0deg, rgba(0, 0, 0, 0.9), transparent);
  //   height: 100%;

  // }

  .slick-image {
    img {
      vertical-align: middle;
    }
  }
  .card-route {
    .play {
      .ico-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 18%;
        transition: all 0.2s ease;
        .ico-play-void {
          transition: none;
        }
        &.ico-play-fill {
          opacity: 0;
        }
      }
      &:hover {
        .ico-play-fill {
          opacity: 1;
        }
        .ico-play-void {
          opacity: 0;
        }
      }
    }
  }
  .content {
    position: absolute;
    // bottom: -24px;
    bottom: 0;
    color: #fff;
    // background: #222;

    padding: 25px 25px 2px 25px;
    width: 100%;
    // transition: all 0.3s ease;

    // &:hover {
    //   background: linear-gradient(0deg,rgba(0,0,0,.9),transparent);
    //   transition: all 0.3s ease;
    // }
    p {
      // text-align: center;
      // margin-bottom: 5px;
      // font-size: 25px;
      // font-weight:600;
    }
  }
  .tags {
    // transition: opacity 0.3s ease-out;
    opacity: 0;
    height: 100%;
    overflow: hidden;
    ul {
      float: left;
      li {
        display: inline-block;
        margin-right: 4px;
        padding-right: 10px;
        position: relative;
        font-size: 13px;

        &::before {
          content: "";
          width: 2px;
          background-color: #eee;
          height: 70%;
          position: absolute;
          right: 0;
          top: 3px;
        }
        &:last-child::before {
          content: none;
        }
      }
    }
    .playlist-btn {
      float: right;
    }
  }
  .card-watchlist-btn {
    float: left;
    margin-bottom: 10px;
    .watchlist-btn {
      background-color: transparent;
      border: 0;
    }
    img {
      width: 22px;
    }
  }
  .duration {
    padding: 4px 15px 15px 4px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), transparent);
    color: #fff;
    left: 0 !important;
    top: 0 !important;
    p {
      font-size: 13px;
    }
  }
  .card-watched {
    position: absolute;
    top: 0;
    right: 0;
    padding: 5px;
    z-index: 2;
    img {
      width: 22px;
    }
  }
  .card-progress {
    position: absolute;
    width: 100%;
    height: 5px;
    background-color: rgba(167, 167, 167, 0.5);
    left: 0;
    bottom: 0;
    margin-top: 3px;
    .progress-percent {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #4558dd;
    }
  }

  &:hover {
    .tags {
      opacity: 1;
      // height: 100%;
    }
  }
}
.card-arrow-down-small {
  // text-align: center;
  // margin: 10px 0;
  cursor: pointer;
  margin: 10px 0 10px 25%;
  // margin-top: 10px;
  // margin-bottom: 10px;
  // margin-left: 25%;
  p {
    color: #ffffff;
    font-family: "ProximanovaBold";
    font-size: 16px !important;
    font-weight: bold;
    float: left;
  }
  img {
    height: 10px !important;
    margin-left: 10px;
    margin-top: 5px;
  }
}
.premieringstatus {
  font-family: "HelveticaNeueMedium";
  color: #d0021b;
}
.premieringtime {
  font-family: "HelveticaNeueMedium";
}
.hover-effect {
  width: 100%;
  height: 100%;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.9), transparent);
    transition: all 0.3s ease;
  }
}
.booking-opens {
  transform: rotate(-45deg);
  text-align: center;
  margin-left: -75%;
  margin-top: 5%;
  background: #ffee23;
  p {
    text-transform: uppercase;
    color: #000000;
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 40px;
    font-family: "ProximanovaBold";
    text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.29);
  }
}
.detail-arrow {
  text-align: center;
  height: 20px;
  img {
    width: 36px;
    margin-top: -8px;
  }
}
.trapezoid-card {
  // border-bottom: 40px solid #ffee23d9;
  border-bottom-width: 40px;
  border-bottom-style: solid;
  border-bottom-color: yellow;
  border-bottom-color: #ffee23d9;
  // background-image: linear-gradient(270deg, #FFF841 0%, #FFF63B 18.96%, rgba(255,243,49,0.65) 47.82%, #FFEF24 83.68%, #FFED1F 100%);
  border-left: 40px solid transparent;
  border-right: 40px solid transparent;
  height: 0;
  width: 170px;
  position: absolute;
  z-index: 10;
  transform: rotate(-45deg);
  top: 5%;
  left: -12%;
  p {
    // background: linear-gradient(270deg, #FFF841 0%, #FFF63B 18.96%, rgba(255,243,49,0.65) 47.82%, #FFEF24 83.68%, #FFED1F 100%);
    text-transform: uppercase;
    color: #000000;
    font-size: 18px;
    letter-spacing: 1px;
    line-height: 40px;
    font-family: "ProximanovaBold";
    text-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.29);
    text-align: center;
    span {
      font-size: 12px;
    }
  }
  &::before {
    content: "";
    content: "";
    /* bottom: -22px; */
    width: 0px;
    height: 0px;
    transform: rotate(31deg);
    position: absolute;

    border-top-width: 4px;
    border-top-style: solid;
    border-top-color: transparent;

    border-right-width: 7px;
    border-right-style: solid;
    border-right-color: yellow;
    border-right-color: #ffee23d9;
    // border-right: 7px solid #555;
    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-bottom-color: transparent;

    // border-bottom: 4px solid transparent;
    top: 38px;
    /* z-index: 10; */
    left: -40px;
  }
  &::after {
    content: "";
    width: 0px;
    height: 0px;
    -webkit-transform: rotate(0deg);
    transform: rotate(15deg);
    position: absolute;

    border-top-width: 4px;
    border-top-style: solid;
    border-top-color: transparent;

    border-right-width: 6px;
    border-right-style: solid;
    border-right-color: yellow;
    border-right-color: #ffee23d9;
    // border-right: 7px solid #555;
    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-bottom-color: transparent;

    // border-top: 4px solid transparent;
    // border-right: 6px solid #ffee23bf;
    // border-bottom: 4px solid transparent;

    top: 37px;
    left: 122px;
  }
}
.triangle-bottom {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-right: 5px solid #555;
  border-bottom: 4px solid transparent;
  top: 27%;
  position: absolute;
  z-index: 10;
  left: 3px;
}
.triangle-top {
  height: 0;
  width: 0;
  border-top: 5px solid transparent;
  border-right: 5px solid #555;
  border-bottom: 4px solid transparent;
  position: absolute;
  z-index: 10;
  left: 40%;
  top: -7px;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.play-button {
  position: absolute;
  top: 40%;
  left: 40%;
  cursor: pointer;
  opacity: 0.85;
  &:hover {
    opacity: 1;
  }
}
.purchasebtn {
  z-index: 1000;
  position: absolute;
  left: 0;
  width: 80% !important;
  /* text-align: center; */
  /* margin: 0 auto; */
  /* transform: translateY(-51%); */
  bottom: 60%;
  margin-left: 10%;
  font-size: 18px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 576px) {
  .trapezoid-card {
    width: 100px;
    top: 2%;
    left: -10%;
    border-bottom-width: 25px;
    border-bottom-style: solid;
    border-bottom-color: yellow;
    border-bottom-color: #ffee23d9;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;

    p {
      font-size: 8px;
      line-height: 25px;
      span{
        font-size: 10px;
      }
    }

    &::before {
      // border-right: 9px solid #555;
      border-right-width: 6px;
      border-right-style: solid;
      border-right-color: yellow;
      border-right-color: #ffee23d9;
      top: 22px;
      left: -25px;
    }
    &::after {
      transform: rotate(15deg);
      position: absolute;
      // border-top: 5px solid transparent;
      // border-right: 7px solid #555;
      // border-bottom: 4px solid transparent;
      //
      border-top-width: 5px;
      border-top-style: solid;
      border-top-color: transparent;

      border-right-width: 8px;
      border-right-style: solid;
      border-right-color: yellow;
      border-right-color: #ffee23d9;
      // border-right: 7px solid #555;
      border-bottom-width: 6px;
      border-bottom-style: solid;
      border-bottom-color: transparent;
      top: 21px;
      left: 65px;
      //
    }
  }
  .content-card {
    height: 210px;
    // height: 330px;
    .tags {
      opacity: 1;
      display: block;
    }
    .hover-effect {
      background: transparent;
    }
  }
  .detail-arrow {
    display: none;
  }
  .card-arrow-down-small {
    display: none;
  }
  .purchasebtn {
    font-size: 10px !important;
    padding: 6px !important;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .content-card {
    // min-width: 230px;
    height: 350px;
    .tags {
      opacity: 1;
      display: block;
    }
    .hover-effect { 
      background: transparent;
    }
  }
  .trapezoid-card {
    left: -10%;
    &::before {
      // border-right: 9px solid #555;
      border-right-width: 9px;
      border-right-style: solid;
      border-right-color: yellow;
      border-right-color: #ffee23d9;
    }
    &::after {
      transform: rotate(15deg);
      position: absolute;
      // border-top: 5px solid transparent;
      // border-right: 7px solid #555;
      // border-bottom: 4px solid transparent;
      //
      border-top-width: 5px;
      border-top-style: solid;
      border-top-color: transparent;

      border-right-width: 7px;
      border-right-style: solid;
      border-right-color: yellow;
      border-right-color: #ffee23d9;
      // border-right: 7px solid #555;
      border-bottom-width: 4px;
      border-bottom-style: solid;
      border-bottom-color: transparent;
      //
      top: 37px;
      left: 120px;
    }
  }
  .purchasebtn {
    font-size: 12px !important;
    padding: 10px !important;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .content-card {
    // min-width: 230px;
    height: 350px;
    .tags {
      opacity: 1;
      display: none;
    }
    .hover-effect {
      background: transparent;
    }
  }
  .trapezoid-card {
    left: -10%;
    &::before {
      // border-right: 9px solid #555;
      border-right-width: 9px;
      border-right-style: solid;
      border-right-color: yellow;
      border-right-color: #ffee23d9;
    }
    &::after {
      transform: rotate(15deg);
      position: absolute;
      // border-top: 5px solid transparent;
      // border-right: 7px solid #555;
      // border-bottom: 4px solid transparent;
      //
      border-top-width: 5px;
      border-top-style: solid;
      border-top-color: transparent;

      border-right-width: 7px;
      border-right-style: solid;
      border-right-color: yellow;
      border-right-color: #ffee23d9;
      // border-right: 7px solid #555;
      border-bottom-width: 4px;
      border-bottom-style: solid;
      border-bottom-color: transparent;
      //
      top: 37px;
      left: 120px;
    }
  }
  .purchasebtn {
    font-size: 12px !important;
    padding: 10px !important;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .content-card {
    // min-width: 270px;
    height: 400px;
  }
}
// 4k
@media screen and (min-width: 1900px) {
  .content-card {
    // min-width: 270px;
    height: 700px;
  }

  .trapezoid-card {
    width: 200px;
    top: 3%;
    left: -10%;
    &::after {
      left: 154px;
    }
    p {
      font-size: 20px;
    }
  }
  .content-card {
    .content {
      padding: 25px;
    }
  }
  .card-arrow-down-small {
    margin: 30px 0 10px 35%;
    img {
      margin-top: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/ContentCard.vue